<template>
  <div
    class="grid-stack"
    ref="gridstack"
    >
    <div
      class="grid-stack-item"
      v-if="widget.tab === currentTab"
      v-for="(widget, idx) in widgets"
      :key="idx"
      :data-gs-x="widget.gsOptions.x" :data-gs-y="widget.gsOptions.y"
      :data-gs-width="widget.gsOptions.w" :data-gs-height="widget.gsOptions.h"
      :widget-id="widget['.key']"
      :ref="'widget-' + widget['.key']"
      >
      <a
        v-if="$can('all', 'Admin')"
        href="#"
        class="grid-stack-item__edit"
        @click.prevent="editWidget(widget)"
        v-b-tooltip.hover
        title="Edit"
        >
        <icon name="pencil" />
      </a>
      <a
        v-if="$can('all', 'Admin')"
        href="#"
        class="grid-stack-item__remove"
        @click.prevent="removeWidget(widget['.key'], widget.dependency)"
        v-b-tooltip.hover
        title="Remove"
        >
        <icon name="remove" />
      </a>
      <span
        v-if="$can('all', 'Admin')"
        class="grid-stack-item__move"
        >
        <icon name="arrows" />
      </span>
      <div
        class="grid-stack-item-content"
        :class="[(widget.classes) ? widget.classes : '']"
        >
        <div class="grid-stack-item__title" v-if="widget.title">
          <h4>{{ widget.title }}</h4>
        </div>
        <div v-if="widget.dataWidget" class="widgetsDataWrapper">
          <JsonEditor
            :objData="getJsonData(widget.dataPath)"
            :path="widget.dataPath"
            @onSave="dataChanged"
            />
        </div>
        <DynamicRender
          v-else
          :template="widget.template"
          :data="widgetsData"
          :computed="widgetsComputed"
          :widgetKey="widget['.key']"
          />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import DynamicRender from '@/components/DynamicRender'
// helpers
import db from '@/services/db'
import gridstack from '@/helpers/gridstack'
import eventBus from '@/helpers/event-bus'

let $ = window.$

export default {
  props: {
    widgets: { type: Array, default: () => ([]) },
    widgetsData: { type: Object, default: () => ({}) },
    widgetsComputed: { type: Object, default: () => ({}) },
    currentTab: { type: String, required: true }
  },
  components: {
    DynamicRender
  },
  computed: {
    ...mapState([
      'widgetToUpdate',
      'activeToolbarItem',
      'toolbarItems',
      'currentDash'
    ])
  },
  methods: {
    editWidget (widget) {
      if (widget.dataWidget) eventBus.$emit('showEditDataWidgetModal', widget)
      else this.$store.commit('editWidget', { key: widget['.key'], insert: true })
    },
    removeWidget (key, dependencies) {
      let confirm = window.confirm('Are you sure?')
      if (!confirm) return
      this.$store.commit('addProcess', {
        process: 'deleteWidget',
        message: 'Deleting'
      })
      gridstack.destroy(this.$refs['widget-' + key])
      db.widgets.delete(key, dependencies, () => {
        this.$store.commit('deleteProcess', 'deleteWidget')
        if (this.widgetToUpdate === key && this.activeToolbarItem === this.toolbarItems[0]) {
          this.$store.commit('removeActiveToolbarItem')
        }
      })
    },
    hideTitle (key) {
      let ref = 'title_' + key
      let el = this.$refs[ref]
      $(el).find('.triggerHide').hide()
      $(el).find('.triggerShow').show()
      $(el).find('.titleContent').hide()
    },
    showTitle (key) {
      let ref = 'title_' + key
      let el = this.$refs[ref]
      $(el).find('.triggerHide').show()
      $(el).find('.triggerShow').hide()
      $(el).find('.titleContent').show()
    },
    getJsonData (path) {
      path = path.slice(1).split('/')
      if (path) {
        let data = this.widgetsData
        for (let key of path) {
          if (!data[key]) {
            data = {}
            break
          }
          data = data[key]
        }
        return data
      } else {
        return this.widgetsData
      }
    },
    dataChanged (newData, path) {
      path = path.slice(1)
      db.widgets.updateDataByPath(path, newData, (err) => {
        if (err) {
          this.$store.commit('addError', err.message)
        }
      })
    }
  },
  mounted () {
    gridstack.init(this.widgets)
    setTimeout(() => {
      if (!this.$can('all', 'Admin')) {
        gridstack.freeze(true, this.$refs.gridstack)
      }
    }, 500)
  },
  updated () {
    gridstack.update()
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.grid-stack-item {
  position: relative;
  &-content {
    border: 1px solid $borderColor1;
  }
  &__edit,
  &__remove,
  &__move {
    display: none;
    position: absolute;
    color: $color2;
    z-index: 1;
  }
  &__move {
    left: 13px;
    top: 3px;
    width: 20px;
    height: 20px;
    cursor: move;
    text-align: center;
    padding-top: 0px;
  }
  &:hover .grid-stack-item__edit,
  &:hover .grid-stack-item__remove,
  &:hover .grid-stack-item__move {
    display: block;
  }
  &__edit {
    right: 34px;
    top: 2px;
    &:hover,
    &:focus {
      color: #0fb203;
    }
  }
  &__remove {
    right: 14px;
    top: 2px;
    &:hover,
    &:focus {
      color: #d64a37;
    }
  }
  .widgetContent {
    position: relative;
  }
}
.widgetsDataWrapper {
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grid.vue